import React from 'react';
import cn from 'classnames';
import { flagSprite } from './flagSprite.js';

var styles = {"flagIcon":"international-phone-input__flagIcon_171nf","flagPlaceholder":"international-phone-input__flagPlaceholder_171nf"};
require('./index.css');

/**
 * Компонент флага в виде иконки.
 */
var FlagIcon = function (_a) {
    var _b = _a.country, country = _b === void 0 ? '' : _b, className = _a.className;
    return flagSprite[country] ? (React.createElement("span", { className: cn(styles.flagIcon, className), "data-test-id": "flag-icon-".concat(country), 
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: { __html: flagSprite[country] } })) : (React.createElement("div", { className: cn(styles.flagPlaceholder, className) }));
};

export { FlagIcon };
